import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/* eslint-disable max-len */
var Icon = function Icon() {
  return /*#__PURE__*/_jsxs("svg", {
    height: "13",
    width: "14",
    viewBox: "0 0 14 13",
    children: [/*#__PURE__*/_jsx("title", {
      children: "Share Icon"
    }), /*#__PURE__*/_jsxs("g", {
      "aria-hidden": "true",
      children: [/*#__PURE__*/_jsx("path", {
        d: "m13.3 6c-.4 0-.7.3-.7.7l-.1 4.8h-11v-4.8c0-.4-.3-.7-.7-.7s-.8.3-.8.7v5.5c0 .4.4.8.8.8h12.3c.4 0 .7-.3.7-.7l.2-5.6c0-.4-.3-.7-.7-.7z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m4.2 4.7c.2 0 .4-.1.5-.2l1.6-1.7v6.3c0 .4.3.7.7.7s.7-.3.7-.7v-6.2l1.5 1.6c.1.2.3.2.5.2s.4-.1.5-.2c.3-.3.3-.7 0-1l-2.5-2.9c-.1-.1-.2-.2-.4-.3-.1 0-.1 0-.2 0h-.1-.1c-.1 0-.3.1-.4.2v.1l-2.8 3c-.3.3-.3.8 0 1 .2 0 .3.1.5.1z"
      })]
    })]
  });
};

export default Icon;